module.exports = __webpack_public_path__ + "img/bg03.aa04e63b.png";